import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppUnavailableService } from './core/async-load/app-unavailable.service';
import { ServiceUnavailablePageComponent } from './core/async-load/service-unavailable-page.component';
import { ThemeService } from './core/services/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ServiceUnavailablePageComponent],
  template: `
    @if (unavailable.showing()) {
      <app-service-unavailable-page />
    } @else {
      <router-outlet />
    }
  `,
  styles: [
    `
      :host {
        display: block;
        min-height: 100%;
      }
    `,
  ],
})
export class AppComponent {
  /** Apply saved theme on boot. */
  private readonly _theme = inject(ThemeService);
  readonly unavailable = inject(AppUnavailableService);
}